// Angular
import { animate, style, transition, trigger } from "@angular/animations";
import { Component, OnInit, Output, Input, EventEmitter } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
// Local services
import { AlertService } from "../../services/alert.service";
import { ClienteService } from "../../services/cliente.service";
import { CommonUtilitiesService } from "../../services/common-utilities.service";
// 3rd libraries
import * as moment from "moment";
import swal from "sweetalert2";
import { NgxPermissionsService } from "ngx-permissions";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ModalConsultaClienteComponent } from "../../components/modal-consulta-cliente/modal-consulta-cliente.component";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";

@Component({
  selector: "app-gestiones-sidebar-precas",
  templateUrl: "./gestiones-sidebar-precas.component.html",
  styleUrls: ["./gestiones-sidebar-precas.component.scss"],
  animations: [
    trigger("inOutAnimation", [
      transition(":enter", [
        style({ height: 0, opacity: 0 }),
        animate("0.3s ease-out", style({ height: 300, opacity: 1 })),
      ]),
      transition(":leave", [
        style({ height: 300, opacity: 1 }),
        animate("0.3s ease-in", style({ height: 0, opacity: 0 })),
      ]),
    ]),
  ],
})
export class GestionesSidebarPrecasComponent implements OnInit {
  @Output() selecttab = new EventEmitter<number>();
  @Output() setDataCliente = new EventEmitter<any>();
  @Output() consultaCliente = new EventEmitter<number>();
  @Output() showDpiAndProductModal = new EventEmitter<any>();

  p = 1;
  itemsPerPage = 10;
  colorFilter = "VERDE";
  beginDate = moment(new Date()).format("YYYY-MM-DD");
  endDate = moment(new Date()).format("YYYY-MM-DD");
  maxDate = moment().endOf("month").format("YYYY-MM-DD");
  beginLimitDate = moment(this.beginDate)
    .subtract(3, "months")
    .format("YYYY-MM-DD");
  usercn;
  filtercnSelected = 1;

  public = 0;
  formContainerWidth = 570;
  order = "desc";
  segmentoActive;
  @Output() selectgestion = new EventEmitter<any>();
  habilitado = 0;
  @Input() set segmentoSelected(value: any) {
    this.segmentoActive = value;
    if (+value === 2) {
      this.precalificaiones = this.auxprecalificaciones;
      this.precalificaiones = this.precalificaiones.filter((preca) => {
        return (
          preca.segmentoProducto === "PRIVADO" &&
          preca.segmentoProducto !== "AG"
        );
      });
    } else if (+value === 3) {
      this.precalificaiones = this.auxprecalificaciones;
      this.precalificaiones = this.precalificaiones.filter((preca) => {
        return (
          preca.segmentoProducto === "ESTADO" && preca.segmentoProducto !== "AG"
        );
      });
    } else if (+value === 4) {
      this.precalificaiones = this.auxprecalificaciones;
      this.precalificaiones = this.precalificaiones.filter((preca) => {
        return preca.segmentoProducto === "AG";
      });
    }  else if (+value === 5) {
      this.precalificaiones = this.auxprecalificaciones;
      this.precalificaiones = this.precalificaiones.filter((preca) => {
        return (
          preca.segmentoProducto === "PAGO_VOLUNTARIO" && preca.segmentoProducto !== "AG"
        );
      });
    }else {
      this.precalificaiones = this.auxprecalificaciones;
    }
  }
  @Input() set refreshPrecas(value: any) {
    const webEvaluationPermission =
      this.ngxPermissionService.getPermission("evaluacionWeb");
    if (value === true && webEvaluationPermission) {
      this.OpenClose();
      this.loaderService.startLoader("loader-global", "loadingDashboard");
      this.clienteservice.ofertaPorMes().then((result) => {
        this.precalificaiones = result;
        this.auxprecalificaciones = result;
        this.Order();
        this.loaderService.stopLoader("loader-global", "loadingDashboard");
      });
    }
  }
  busqueda: string;
  term = "";
  // ----------
  token: string;
  listABF = [];
  precalificaiones = [];
  auxprecalificaciones = [];
  constructor(
    private alertService: AlertService,
    private http: HttpClient,
    private loaderService: NgxUiLoaderService,
    private ngxPermissionService: NgxPermissionsService,
    private utilitiesService: CommonUtilitiesService,
    public clienteservice: ClienteService,
    public dialog: MatDialog
  ) {
    utilitiesService.refresh.subscribe((isRefresh) => {
      if (isRefresh === true) {
        this.loadDateFilters();
        this.OpenClose();
      }
    });
    setTimeout(() => {
      if (window.localStorage.getItem("datacn") != null) {
        this.usercn = JSON.parse(window.localStorage.getItem("datacn"));
        if (this.usercn.codigocn == 0) {
          this.filtercnSelected = 0;
        }
      } else {
        this.clienteservice.logOut();
      }
    }, 1500);
  }

  ngOnInit() {
    this.token = localStorage.getItem("token");
    this.loaderService.stopLoader("loader-global", "loadingDashboard");
  }

  loadDateFilters() {
    const webEvaluationPermission =
      this.ngxPermissionService.getPermission("evaluacionWeb");
    if (webEvaluationPermission) {
      this.precalificaiones = [];
      this.auxprecalificaciones = [];
      this.loaderService.startLoader("loader-global", "loadingDashboard");
      this.clienteservice
        .ofertaPorMes(
          moment(this.beginDate).format("DD/MM/YYYY"),
          moment(this.endDate).format("DD/MM/YYYY"),
          this.colorFilter,
          this.filtercnSelected == 1 ? this.usercn.codigocn : 0
        )
        .then((result) => {
          this.precalificaiones = result;
          this.auxprecalificaciones = result;
          this.Order();
          this.loaderService.stopLoader("loader-global", "loadingDashboard");
        });
    }
  }

  OpenClose() {
    this.habilitado = this.habilitado === 1 ? 0 : 1;
    this.habilitado === 1
      ? (this.formContainerWidth = 500)
      : (this.formContainerWidth = 0);
  }

  Search() {
    this.precalificaiones = this.precalificaiones.filter((item) =>
      item.name.match(this.busqueda)
    );
  }

  Order() {
    if (this.order === "asc") {
      this.precalificaiones = this.precalificaiones.sort(
        (a, b) => a.noPrecalificacion - b.noPrecalificacion
      );
    } else {
      this.precalificaiones = this.precalificaiones.sort(
        (a, b) => b.noPrecalificacion - a.noPrecalificacion
      );
    }
  }
  showBusqueda() {
    const dialogRef = this.dialog.open(ModalConsultaClienteComponent, {
      width: "500px",
      height: "auto",
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (!result || result == '') {
        return
      }
      const webEvaluationPermission =
        this.ngxPermissionService.getPermission("evaluacionWeb");
      if (webEvaluationPermission) {
        //consulta por numero de precalificación
        this.precalificaiones = [];
        this.auxprecalificaciones = [];
        this.loaderService.startLoader("loader-global", "loadingDashboard");
        if (result.codigoConsulta == 1) {
          this.clienteservice
            .getPrecalificacion(result.parametroConsulta)
            .then((snapshot) => {
              let aux = {
                origen: snapshot.informacionGeneral.origen,
                estadoColorPrecalificacion: snapshot.estadoColorPrecalificacion,
                noPrecalificacion: result.parametroConsulta,
                participante: [
                  {
                    dpi: snapshot.participante[0].datosGenerales.dpi,
                    nombreCompleto:
                      snapshot.participante[0].datosGenerales.primerNombre +
                      " " +
                      snapshot.participante[0].datosGenerales.primerApellido,
                    tipoParticipante: "DEUDOR",
                  },
                ],
              };
              this.precalificaiones.push(aux);
              this.auxprecalificaciones.push(aux);
              this.setGestion(aux);
            })
            .catch((error) => {
              this.loaderService.stopLoader(
                "loader-global",
                "loadingDashboard"
              );
              this.alertService.show("Alerta", "Un error ha ocurrido");
            });
        } else if (result.codigoConsulta == 2) {
          this.clienteservice.getPrecalificacionesPorCliente(result.parametroConsulta, result.fechaInicio, result.fechaFin).then(snapshot => {
            this.precalificaiones = snapshot;
            this.auxprecalificaciones = snapshot;
            this.selectedtab(0)
            this.Order();
            this.loaderService.stopLoader("loader-global", "loadingDashboard");
          })
        }
        else if (result.codigoConsulta == 3) {
          this.selectedtab(0);
          this.OpenClose();
          this.consultaCliente.emit(result.parametroConsulta)
        }
      }
    });
  }

  showDpiAlert() {
    this.selectedtab(0);
    this.OpenClose();
    this.showDpiAndProductModal.emit({pageOrigin:'sidebarPrecas'})

  }
  setGestion(gestion) {
    const testDetailPermission =
      this.ngxPermissionService.getPermission("detalleEvaluacion");
    if (testDetailPermission) {
      this.loaderService.startLoader("loader-global", "loadingDashboard");
      this.selectgestion.emit(gestion);
    } else {
      this.alertService.show(
        "Nota",
        "No tienes permiso para acceder a este módulo"
      );
    }
  }
  selectedtab(tab) {
    this.selecttab.emit(tab);
  }
}
